export enum SchedulerTypeEnum {
  SINGLE = 'SINGLE',
  SERIES = 'SERIES',
}
